export const LoyaltyMarketing = {
    "loyaltyMarketing.benefitsRewards": "benefitsRewards",
    "loyaltyMarketing.dynamicRedirection": "dynamicRedirection",
    "loyaltyMarketing.dynamicRedirectionBanner": "dynamicRedirectionBanner",
    "loyaltyMarketing.dynamicRedirectionFooter": "dynamicRedirectionFooter",
    "loyaltyMarketing.earnPoints": "earnPoints",
    "loyaltyMarketing.heroSection": "heroSection",
    "loyaltyMarketing.howItWorks" : "howItWorks",
    "loyaltyMarketing.pointBenefit": "pointBenefit",
    "loyaltyMarketing.tierBenefits": "tierBenefits"
};
